module.exports = __webpack_public_path__ + "img/bathroom-amenities.5a07fffe.svg";